import { styled, css } from '@mui/material/styles';
import { Button as _Button } from '~/components/commons/Button';
import { ComponentType } from 'react';

export const Button = styled(_Button)`` as ComponentType<any>;
